import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { ResponsiveContainer } from "recharts";
import FormDialog from "./FormDialog";
import moment from "moment";
import LinearBuffer from "./LinearBuffer";
import {
  // NotificationManager,
  NotificationContainer,
} from "react-notifications";

const SearchResults = (props) => {
  // 1. Destructure BOTH filteredData and isLoading from props
  const { filteredData, isLoading } = props;

  return (
    <>
      <ResponsiveContainer>
        <div className="table-responsive-material">
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell>SN</TableCell> */}
                <TableCell align="left">Added Date/Time</TableCell>
                <TableCell align="left">Customer</TableCell>
                <TableCell align="left">Address</TableCell>
                <TableCell align="left">Suburb</TableCell>
                <TableCell align="left">Phone</TableCell>
                <TableCell align="left">Call Type</TableCell>
                <TableCell align="left">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* 2. Implement the new rendering logic */}
              {isLoading ? (
                // If it's loading, show the buffer
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <LinearBuffer />
                  </TableCell>
                </TableRow>
              ) : filteredData && filteredData.length > 0 ? (
                // If NOT loading AND data exists, show the data
                filteredData.map((n, index) => {
                  return (
                    <TableRow key={index}>
                      {/* <TableCell>{counter++}</TableCell> */}
                      <TableCell align="left">
                        {moment(n.addedDate + " " + n.addedTime).format(
                          "Do MMM, h:mm a"
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {n.firstName} {n.lastName}
                      </TableCell>
                      <TableCell align="left">{n.address}</TableCell>
                      <TableCell align="left">{n.suburb}</TableCell>
                      <TableCell align="left">{n.phone}</TableCell>
                      <TableCell align="left" style={{ color: "#b5b5b5" }}>
                        {n.messageType}
                      </TableCell>
                      <TableCell align="left">
                        {
                          <>
                            {/* Pass all props to the dialog for simplicity */}
                            <FormDialog
                              {...n}
                              commentText={n.commentText || n.message}
                            />
                          </>
                        }
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                // If NOT loading AND there's no data, show the "No Results" message
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <h4 style={{ marginTop: "1%" }}>No Records Found!</h4>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <NotificationContainer />
        </div>
      </ResponsiveContainer>
    </>
  );
};

export default SearchResults;
